/**
 * API呼び出しの結果を表す型
 * 成功時はdataを、失敗時はerrorメッセージを含む
 */
export type ApiResult<T = void> = { success: true; data: T } | { success: false; error: string };

/**
 * 成功結果を生成するヘルパー関数
 */
export function success<T>(data: T): ApiResult<T> {
  return { success: true, data };
}

/**
 * 失敗結果を生成するヘルパー関数
 */
export function failure(error: string): ApiResult<never> {
  return { success: false, error };
}
